import classNames from 'classnames';
import React, { useContext } from 'react';
import { DropMenu } from 'venn-ui-kit';
import Label from '../../label';
import { UserContext } from '../../contexts';
import { getContextMenuItems } from '../../utils';
import type { ActionEnum } from 'venn-api';

interface OwnershipContextSelectorProps {
  setOwnerContextId: (x: string) => void;
  ownerContextId?: string;
  disabled?: boolean;
  requiredAction: ActionEnum;
  className?: string;
  refreshedStyling?: boolean;
  customLabel?: string;
}

const qaClass = 'qa-portfolio-ownership';

export const OwnershipContextSelector = ({
  disabled,
  ownerContextId,
  setOwnerContextId,
  requiredAction,
  className,
  refreshedStyling = false,
  customLabel,
}: OwnershipContextSelectorProps) => {
  const userContextValue = useContext(UserContext);
  const { currentContext } = userContextValue;
  const availableContexts = userContextValue.profileSettings?.availableContexts;
  const items = getContextMenuItems(availableContexts, currentContext, requiredAction);
  const labelText = customLabel ?? 'Ownership:';

  return (
    <div className={classNames('mt-[20px]', className, qaClass)}>
      {!refreshedStyling && <Label required>{labelText}</Label>}
      <DropMenu
        disabled={disabled}
        selected={ownerContextId}
        onChange={(item) => setOwnerContextId(item.value)}
        items={items}
        searchable
        placeholder="Select ownership"
        minimumItemsToTrigger={1}
      />
    </div>
  );
};
